var map = {
	"./ID.webp": 781,
	"./INDO.webp": 782,
	"./MY.webp": 783,
	"./TH.webp": 784,
	"./VN.webp": 785,
	"./malaysia.webp": 786
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 396;
module.exports = webpackAsyncContext;